<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M5 2.25C2.92893 2.25 1.25 3.92893 1.25 6V18C1.25 20.0711 2.92893 21.75 5 21.75H19C21.0711 21.75 22.75 20.0711 22.75 18V6C22.75 3.92893 21.0711 2.25 19 2.25H5ZM2.75 6C2.75 4.75736 3.75736 3.75 5 3.75H19C20.2426 3.75 21.25 4.75736 21.25 6V18C21.25 19.2426 20.2426 20.25 19 20.25H17.9889C17.8966 18.7786 17.2652 17.3887 16.21 16.3497C15.0874 15.2446 13.5753 14.6251 12 14.6251C10.4248 14.6251 8.91265 15.2446 7.79012 16.3497C6.73486 17.3887 6.10345 18.7786 6.01119 20.25H5C3.75736 20.25 2.75 19.2426 2.75 18V6ZM9.68563 7.95866C9.07181 8.57248 8.72697 9.40499 8.72697 10.2731C8.72697 11.1411 9.07181 11.9736 9.68563 12.5875C10.2994 13.2013 11.132 13.5461 12 13.5461C12.8681 13.5461 13.7006 13.2013 14.3144 12.5875C14.9283 11.9736 15.2731 11.1411 15.2731 10.2731C15.2731 9.40499 14.9283 8.57248 14.3144 7.95866C13.7006 7.34484 12.8681 7 12 7C11.132 7 10.2994 7.34484 9.68563 7.95866Z"
		fill="currentColor"
	/>
</svg>
